define([
    'angular',
    './ilmn-ui-nav/main',
    './ilmn-ui-toolbar/main',
    './ilmn-ui-comments/main',
    './ilmn-ui-loading-animation/main',
    './ilmn-ui-utils/main',
    './ilmn-ui-alert-banner/main',
    './ilmn-ui-idle/main',
], function(angular, IlmnUiNav, IlmnUiToolbar, IlmnUiComments, IlmnUiLoadingAnimations, IlmnUiUtils, IlmnUiAlertBanner, IlmnUiIdle) {
    'use strict';

    var MODULE_NAME = 'ilmn-ui-core';

    return angular
        .module(MODULE_NAME, [IlmnUiNav, IlmnUiToolbar, IlmnUiComments, IlmnUiUtils, IlmnUiLoadingAnimations, IlmnUiAlertBanner, IlmnUiIdle])
        .name;
});



//////////////////
// WEBPACK FOOTER
// ./module.js
// module id = 1
// module chunks = 0